// eslint-disable-next-line no-use-before-define
import React from "react";
import rehypeReact, {
  ComponentProps,
  ComponentPropsWithNode,
} from "rehype-react";
// eslint-disable-next-line import/no-extraneous-dependencies
import unified from "unified";
import { Node } from "unist";

import { NextLink } from "@/components/Blog/NextLink";
import { NextImage } from "@/components/Blog/NextImage";

/* eslint-disable react/display-name */
const options = {
  createElement: React.createElement,
  Fragment: React.Fragment,
  passNode: true,
  components: {
    Link: (props: ComponentProps) => (
      <NextLink {...(props as ComponentPropsWithNode)} />
    ),
    Image: (props: ComponentProps) => (
      <NextImage {...(props as ComponentPropsWithNode)} />
    ),
  },
};

const renderAst = unified().use(rehypeReact, options);

interface RenderContentProps {
  htmlAst: Node | null;
}

export const RenderContent = ({ htmlAst }: RenderContentProps) => {
  if (!htmlAst) return null;
  return <>{renderAst.stringify(htmlAst)}</>;
};

// <div className="post-content load-external-scripts">{renderAst.stringify(htmlAst)}</div>
